import { RouteType } from "constants/RouteType";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { AuthService } from "services/auth/AuthService";

export class ContactEnquiryService {

  // To Get Contact Enquiry List

  static getContactEnquiryList = async (requestBody: PaginatorModel) => {
    const url = RouteType.ADMIN + RouteType. CONTACT_ENQUIRY;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };
}